import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import logo from '../img/logo.png';

const Footer = () => {
  const whatsappNumber = "525624480446";
  const whatsappNumberTwo = "525524459007";
  const emailAddress = "contacto@3vertices.com";

  return (
    <footer className="footer-section">
      <div className="footer-glass-container">
        <div className="footer-content">

          <div className="footer-brand">
            <img src={logo} alt="Logo 3 Vertices" className="footer-logo" />
            <p className="brand-description">
              Ingeniería de software de alto nivel. Transformamos procesos complejos en soluciones digitales escalables y seguras.
            </p>
          </div>

          <div className="footer-group">
            <h3 className="footer-title">Navegación</h3>
            <ul className="footer-links">
              <li><a href="#servicios">Servicios</a></li>
              <li><a href="#historia">Acerca de</a></li>
              <li><a href="#preguntas">FAQ</a></li>
              <li><a href="#contacto">Contacto</a></li>
            </ul>
          </div>

          <div className="footer-group contact-info">
            <h3 className="footer-title">Contacto Directo</h3>
            <div className="contact-item">
              <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} className="icon-blue" /> (+52) 56 2448 0446
              </a>
            </div>
            <div className="contact-item">
              <a href={`https://wa.me/${whatsappNumberTwo}`} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} className="icon-blue" /> (+52) 55 2445 9007
              </a>
            </div>
            <div className="contact-item">
              <a href={`mailto:${emailAddress}`} className="email-link">
                <FontAwesomeIcon icon={faEnvelope} className="icon-blue" /> {emailAddress}
              </a>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} <strong>3 Vértices</strong>. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;